import { render, staticRenderFns } from "./onebox-publicfolder.vue?vue&type=template&id=f9d66472&"
import script from "./onebox-publicfolder.vue?vue&type=script&lang=js&"
export * from "./onebox-publicfolder.vue?vue&type=script&lang=js&"
import style0 from "./onebox-publicfolder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports